<template>
  <div class="restrictedDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        :value="selectedCountry.text"
        :label="$t.meta.country"
        :placeholder="isView ? '' : $t.meta.select"
        @click="onShowEmit('showRestrictedDetailCountry')"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <van-field
        :value="selectedCity.text"
        :label="$t.meta.city"
        :placeholder="isView ? '' : $t.meta.select"
        @click="onShowEmit('showRestrictedDetailCity')"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <van-field
        v-model="selectedCustomer.text"
        :label="$t.marketRisk.entrustEnterprise"
        :placeholder="isView ? '' : $t.meta.input"
        @click="onShowEmit('showRestrictedDetailCustomer')"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.CompanyNameEn"
        :label="$t.marketRisk.companyNameEn"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.CompanyNameSn"
        :label="$t.marketRisk.companyNameSn"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.LegalPerson"
        :label="$t.marketRisk.legalPerson"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.LegalPersonPhone"
        :label="$t.marketRisk.legalPersonPhone"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.BusinessLicenseNo"
        :label="$t.marketRisk.businessNo"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.SalesName"
        :label="$t.marketRisk.salesName"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.SalesPhone"
        :label="$t.marketRisk.salesPhone"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
      />

      <van-field
        v-model="form.UserName"
        :label="$t.marketRisk.addPeople"
        disabled
        v-if="isView"
      />

      <div style="margin: 16px" v-if="!isView">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>

      <option-list
        event="showRestrictedDetailCountry"
        :options="countryList"
        @onSelect="onSelectCountry"
      ></option-list>

      <option-list
        event="showRestrictedDetailCity"
        :options="cityList"
        @onSelect="onSelectCity"
      ></option-list>

      <fetch-list
        event="showRestrictedDetailCustomer"
        type="customerManagement"
        request="getCustomerInfoSearchList"
        @onSelect="onSelectCustomer"
      ></fetch-list>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  Uploader,
} from "vant";
import OptionList from "@components/optionList/OptionList.vue";
import FetchList from "@components/fetchList/FetchList.vue";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(Uploader);

export default {
  name: "restrictedDetail",
  components: {
    OptionList,
    FetchList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isView: false,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      selectedCountry: { text: "", value: null },
      selectedCity: { text: "", value: null },
      selectedCustomer: { text: "", value: null, CustomerNumber: "" },
      //选项
      countryList: [],
      cityList: [],
    };
  },
  created() {
    const { IsView } = this.$route.query;
    this.isView = IsView;
    if (IsView) {
      var data = JSON.parse(localStorage.getItem("restrictedDetail"));
      this.form = data;
      this.getOptions().then((success) => {
        if (success) this.firstLoad();
      });
    } else {
      this.form = {
        CountryId: null,
        CityId: null,
        CustomerNumber: "",
        CompanyName: "",
        CompanyNameEn: "",
        CompanyNameSn: "",
        LegalPerson: "",
        LegalPersonPhone: "",
        BusinessLicenseNo: "",
        SalesName: "",
        SalesPhone: "",
        CompanyId: "",
        UserId: "",
      };
      this.getOptions();
    }
  },
  methods: {
    firstLoad() {
      //国家
      var country = this.countryList.find((c) => c.value == this.form.CountryId);
      if (country) {
        this.selectedCountry.text = country.text;
        this.selectedCountry.value = country.value;
      }
      //城市
      var city = this.cityList.find((c) => c.value == this.form.CityId);
      if (city) {
        this.selectedCity.text = city.text;
        this.selectedCity.value = city.value;
      }
      //客户
      this.selectedCustomer.text = this.form.CompanyName;
      this.selectedCustomer.CustomerNumber = this.form.CustomerNumber;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCountryList(), this.getCityList()]).then((success) => {
          if (success) {
            resolve(true);
          }
          this.$commonMethod.hideLoading();
        });
      });
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCityList() {
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList({
            type: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.City_cn + "," + item.City_en,
                value: item.Id,
              };
              result.push(data);
            });
            this.cityList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSelectCountry(item) {
      this.selectedCountry.text = item.text;
      this.selectedCountry.value = item.value;
    },
    onSelectCity(item) {
      this.selectedCity.text = item.text;
      this.selectedCity.value = item.value;
    },
    onSelectCustomer(item) {
      this.selectedCustomer.text = item.text;
      this.selectedCustomer.value = item.value;
      this.selectedCustomer.CustomerNumber = item.CustomerNumber;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      if (this.isView) {
        return;
      }
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      param.UserId = this.UserId;
      param.CountryId = this.selectedCountry.value;
      param.CityId = this.selectedCity.value;
      param.CustomerNumber = this.selectedCustomer.CustomerNumber;
      param.CompanyName = this.selectedCustomer.text;
      this.$api.marketRisk
        .addCustomerRestricted(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.restrictedDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .restrictedDetail-radio {
    background: #ffffff;
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      font-size: 14px;
    }
  }
}
</style>
